<template>
	<div class="no-results">
		<p>{{ content }}</p>
		<span class="fa fa-grin-wink"></span>
	</div>
</template>

<script>

const defaultText = 'Nothing Added Yet';
const defaultFilteredText = 'No Results Found';

export default {

	props: {
		text: {
			type: String,
			default: defaultText,
		},

		filteredText: {
			type: String,
			default: defaultFilteredText,
		},

		isFiltered: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		content() {
			if (this.isFiltered) {
				return defaultFilteredText;
			}

			return this.text;
		},
	},
};

</script>
